import DataNotFound from 'components/DataNotFound/DataNotFound';
import DistributionDonut from 'components/AiAnalytics/shared/DistributionDonut/DistributionDonut';
import { BaseWidget } from 'models/WidgetModel';
import React, { useMemo } from 'react';
import { mapDispositionChangeResponse } from './dispositionChange.mapper';
import './DispositionChange.scss';

const DispositionChange: React.FC<BaseWidget> = ({ response }) => {
  const view = useMemo(() => mapDispositionChangeResponse(response), [response]);
  if (!view) return <DataNotFound />;
  if (!view.hasActivity) return <div className="disposition-change__no-activity">No activity</div>;
  return (
    <div className="disposition-change">
      <div className="disposition-change__distribution">
        <DistributionDonut
          segments={view.segments}
          centerValue={`${view.dominantPct}%`}
          centerLabel={view.dominant.label}
          accessibleLabel={`Disposition change: ${view.segments
            .map(({ label, value }) => `${label} ${value}%`)
            .join(', ')}`}
        />
        <ul className="disposition-change__legend">
          {view.segments
            .filter((segment) => segment.value > 0)
            .map((segment) => (
              <li key={segment.id}>
                <span style={{ backgroundColor: segment.color }} aria-hidden="true" />
                {segment.label}
                <strong>{segment.value}%</strong>
              </li>
            ))}
        </ul>
      </div>
      {view.reasons.length > 0 ? (
        <section className="disposition-change__reasons">
          <h3>{view.reasonsHeading}</h3>
          <ul>
            {view.reasons.map((reason) => (
              <li key={reason.label}>
                <span>{reason.label}</span>
                <strong>{reason.count.toLocaleString('en-US')}</strong>
              </li>
            ))}
          </ul>
        </section>
      ) : null}
    </div>
  );
};
export default DispositionChange;
